export default {
  tplaylists (state) {
      return state.playlists
    },
    selectedTPlaylist (state) {
        return state.selectedTPlaylist
    },
    getFilterResults (state) {
      return state.filterResults
    },
    getPlaylist: state => (id) => {
      return state.tplaylists.find(item => item.playlistId == id)
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/trendingPlaylists/getters.js